// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCHJU6ibogmsPr9nuyHUPIsroFUl9CcNxw",
  authDomain: "cheap-naira.firebaseapp.com",
  projectId: "cheap-naira",
  storageBucket: "cheap-naira.appspot.com",
  messagingSenderId: "280908251727",
  appId: "1:280908251727:web:b4e7060d0c9f9a1a92603a",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)
export const db = getFirestore(app)
